"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_Starbreaker_OnAttackEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
let Effect_Starbreaker_OnAttackEventHandlerScript = class Effect_Starbreaker_OnAttackEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.Attack) {
            return;
        }
        if (!event.args.hit) {
            return;
        }
        container.applyDebuff({
            sequence,
            attackerId: event.subject,
            targetId: event.args.targetId,
            duration: Duration_1.Duration.Turns(4),
            effect: new core_1.BurningLightEffectArgs("Power", 10)
        });
        container.applyDebuff({
            sequence,
            attackerId: event.subject,
            targetId: event.args.targetId,
            effect: new core_1.DarknessEffectArgs(),
            duration: Duration_1.Duration.Turns(4),
        });
    }
};
Effect_Starbreaker_OnAttackEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_Starbreaker_OnAttack")
], Effect_Starbreaker_OnAttackEventHandlerScript);
exports.Effect_Starbreaker_OnAttackEventHandlerScript = Effect_Starbreaker_OnAttackEventHandlerScript;
